import { useMutation } from "@tanstack/react-query";
import {
  AddImages,
  CreateGuide,
  DeleteGuide,
  DragAndDropGuide,
  UpdateGuide,
} from "../../../Api/guide";

export const useMutateCreateGuide = () =>
  useMutation({
    mutationFn: (data) => CreateGuide(data),
  });

export const useMutateEditGuide = () =>
  useMutation({
    mutationFn: (data) => UpdateGuide(data),
  });

export const useMutateDeleteGuide = () =>
  useMutation({
    mutationFn: (data) => DeleteGuide(data),
  });

export const useMutateCreateImage = () =>
  useMutation({
    mutationFn: (data) => AddImages(data),
  });

export const useMutateDragDropGuide = () =>
  useMutation({
    mutationFn: (data) => DragAndDropGuide(data),
  });
